import React from 'react';
import PropTypes from 'prop-types';
import { StyledBar } from './Bar.styled';
function Bar(_ref) {
  var children = _ref.children,
    color = _ref.color,
    position = _ref.position;
  return /*#__PURE__*/React.createElement(StyledBar, {
    color: color,
    position: position
  }, children);
}
Bar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'primaryAlt', 'secondary', 'secondaryAlt', 'tertiary', 'transparent']),
  /**
   * The positioning type.
   */
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
} : {};
Bar.defaultProps = {
  color: 'transparent',
  position: 'relative'
};
export default Bar;